"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFloatLocales = exports.isFloat = void 0;
const assertString_1 = require("./util/assertString");
const alpha_1 = require("./alpha");
function isFloat(str, options = {}) {
    (0, assertString_1.assertString)(str);
    const float = new RegExp(`^(?:[-+])?(?:[0-9]+)?(?:\\${options.locale ?
        alpha_1.decimal[options.locale] :
        '.'}[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$`);
    if (str === '' || str === '.' || str === '-' || str === '+') {
        return false;
    }
    const value = parseFloat(str.replace(',', '.'));
    return float.test(str) &&
        (!options.min || value >= options.min) &&
        (!options.max || value <= options.max) &&
        (!options.lt || value < options.lt) &&
        (!options.gt || value > options.gt);
}
exports.isFloat = isFloat;
exports.isFloatLocales = Object.keys(alpha_1.decimal);
